import { FacilityType } from "./FacilityType";
import { Person } from "./Person";

  export class Facility {

    constructor(
        public id:string,
        public name:string,
        public building:string,
        public floor:string,
        public facilityType:FacilityType,
        public locationId:string,
        public created: Date,
        public owner:Person | null
    ) {}

}